<div class="header">
    <h2 class="title"><strong>Assignments</strong></h2>
    <mat-icon
        class="close-button"
        matTooltip="Close"
        (click)="closePopup()"
        >close</mat-icon
    >
</div>
<mat-dialog-content>
    <las-user-assignments [hideTitle]="true"></las-user-assignments>
</mat-dialog-content>
